import React from "react";
import PropTypes from "prop-types";
import { Modal } from "../../components/Modal/Modal";
import Button from "../../components/Button/Button";
import styles from "./ChangeSubscriptionModal.module.css";
import Loader from "../Loader/Loader";

const ChangeSubscriptionModal = ({
  isOpen,
  onCloseButtonClick,
  onConfirmCancel,
  billingCycle,
  changeSubError,
  isLoading,
}) => {
  return (
    <div className="container">
      <Modal
        isOpen={isOpen}
        className="modal"
        header="Confirm New Subscription"
        footer={
          <div className={styles.footerButtons}>
            <button
              className={"btn"}
              id={styles.noButton}
              onClick={onCloseButtonClick}
            >
              Cancel
            </button>{" "}
            <button
              className={"btn"}
              id={styles.confirmButton}
              onClick={onConfirmCancel}
            >
              Confirm
            </button>
          </div>
        }
      >
        <div>
          {/* NOT WORKING TODO___ FIX ME */}
          {isLoading ? (
            <div className={styles.loaderContainer}>
              <Loader color={"#3c4554"} size={75} />
            </div>
          ) : (
            <div>
              {billingCycle === 1 ? (
                <div>
                  <p>
                    Your charge will be processed immediately, and your
                    subscription will be billed each month on today’s date until
                    canceled.
                  </p>
                  <p>
                    You’ll immediately have access to all web and mobile apps in
                    your new subscription, and you’ll retain access to all apps
                    in your previous subscription until the end of that billing
                    cycle.
                  </p>
                  <p>
                    If you have additional questions, reach out to tech support
                    at <b>tech@bidpro.com.</b>
                  </p>
                  <p>Select Confirm to start your new subscription type.</p>
                </div>
              ) : (
                <>
                  <p>
                    Your charge will be processed immediately, and your
                    subscription will be billed annually on today’s date until
                    canceled.
                  </p>
                  <p>
                    You’ll immediately have access to all web and mobile apps in
                    your new subscription, and you’ll retain access to all apps
                    in your previous subscription until the end of that billing
                    cycle.
                  </p>
                  <p>
                    If you have additional questions, reach out to tech support
                    at <b>tech@bidpro.com.</b>
                  </p>
                  <p>Select Confirm to start your new subscription type.</p>
                </>
              )}
              {changeSubError && (
                <div className={styles.changeError}>
                  <p>{changeSubError}</p>
                </div>
              )}
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

ChangeSubscriptionModal.propTypes = {
  isOpen: PropTypes.bool,
  onCloseButtonClick: PropTypes.func,
  onConfirmCancel: PropTypes.func,
  changeSubError: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default ChangeSubscriptionModal;
